export const SET_HUB_DATA = 'SET_HUB_DATA'
export const SET_PAIRING_INFO = 'SET_PAIRING_INFO'
export const SET_INTERVAL = 'SET_INTERVAL'
export const SET_TOOLS = 'SET_TOOLS'
export const SET_CONNECTED_DEVICES = 'SET_CONNECTED_DEVICES'
export const RESET_SERVICE_REQUEST = 'RESET_SERVICE_REQUEST'
export const SET_SERVICE_REQUEST = 'SET_SERVICE_REQUEST'
export const SET_CHAT_STATUS = 'SET_CHAT_STATUS'
export const SET_EDIT_STATUS = 'SET_EDIT_STATUS'
export const SET_MONITOR_INFO = 'SET_MONITOR_INFO'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_STATUS = 'SET_STATUS'
export const SET_REQUEST = 'SET_REQUEST'
export const SET_TOOL = 'SET_TOOL'
export const SET_TECH = 'SET_TECH'
export const SET_TECH_STATUS = 'SET_TECH_STATUS'
export const SET_TOOL_STATUS = 'SET_TOOL_STATUS'
export const SET_SCANTYPE = 'SET_SCANTYPE'
export const SET_HOST = 'SET_HOST'
export const SET_REQUESTDEVICES = 'SET_REQUESTDEVICES'
export const SET_WAIT_TIME = 'SET_WAIT_TIME'



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/types.js